export default "__VITE_ASSET__CvWqLtiL__"